import styled from 'styled-components'

export const Shell = styled.div`
  background-color: white;
  border: 1px solid #e4e6e7;
`

export const Card = styled(Shell)`
  padding: 24px;
`
